import React, { useEffect } from 'react';
import { G7CloudHeader } from './G7CloudHeader';
import { SuspensionNotice } from './SuspensionNotice';
import { ResellerInfo } from './ResellerInfo';
import { G7CloudPitch } from './G7CloudPitch';
import { G7CloudFooter } from './G7CloudFooter';
export function SuspensionPage() {
  useEffect(() => {
    document.title = 'G7Cloud WordPress Hosting';
  }, []);
  return <div className="min-h-screen w-full bg-slate-50 flex flex-col" data-id="element-101">
      <G7CloudHeader data-id="element-102" />

      <main className="flex-1 w-full" data-id="element-103">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-16 space-y-12 sm:space-y-16" data-id="element-104">
          {/* Primary: Suspension notice — dominant element */}
          <SuspensionNotice data-id="element-105" />

          {/* Secondary: What this means for the visitor */}
          <ResellerInfo data-id="element-106" />

          {/* Tertiary: Subtle G7Cloud pitch */}
          <G7CloudPitch data-id="element-107" />
        </div>
      </main>

      <G7CloudFooter data-id="element-108" />
    </div>;
}